export default __webpack_public_path__ + "static/Mac screen@2x-min1-c7431ff04713823166c8c8486a27e6e8.png";